import { DEFAULT_SMART_LIST_SORT_OPTION } from "../../Api/constants";
import { getTemplateById } from "../../constants/smartListOptions";

export type SmartListState = {
    templateId: string;
    adapterId: number | null;
    genre: string;
    labels: string[];
    sortOption: string;
};

export const createInitialSmartListState = (): SmartListState => ({
    templateId: "",
    adapterId: null,
    genre: "",
    labels: [],
    sortOption: DEFAULT_SMART_LIST_SORT_OPTION,
});

export const normalizeLabel = (label: string): string => label.trim().toLowerCase();

export const normalizeGenre = (genre: string): string => genre.trim().toLowerCase();

export const deriveSmartListOptions = (
    state: SmartListState,
): {
    requiresGenre: boolean;
    requiresLabels: boolean;
    normalizedGenre?: string;
    normalizedLabels?: string[];
} => {
    const definition = getTemplateById(state.templateId);
    const requiresGenre = definition?.requiresGenre ?? false;
    const requiresLabels = definition?.requiresLabels ?? false;

    const normalizedGenre = requiresGenre && state.genre ? normalizeGenre(state.genre) : undefined;

    const normalizedLabels =
        requiresLabels && state.labels.length > 0
            ? state.labels
                  .map((label) => normalizeLabel(label))
                  .filter((value) => value.length > 0)
                  .slice(0, 1)
            : undefined;

    return { requiresGenre, requiresLabels, normalizedGenre, normalizedLabels };
};
